export default "__VITE_ASSET__93nr3whdmhX5oxfziNzB$g__"